export const inboxGridItemFrag = `
    id
    address
    credit
    deleteMessagesAfter
    name
    status
    type
    username
`;
